import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '../../IconButton/IconButton';

function SelectedPlan({ plan, onRemove }) {
    const removePlan = () => {
        onRemove(plan);
    };
    let planName = plan.name;
    const programNamesJoined = plan.programNames.filter(pn => pn.checked).map(pn => pn.name)
        .join(', ');

    if (programNamesJoined) {
        planName = `${plan.name} - ${programNamesJoined}`;
    }

    return (
        <li className={'icon-caption'}>
            <IconButton icon={'cancel'}
                role="button"
                tabIndex="0"
                iconClassName="filter-box__close-icon"
                clickHandler={removePlan}
                ariaLabel="remove program filter"
            />
            <span className="icon-caption__text">
                {planName}
            </span>
        </li>
    );
}


SelectedPlan.propTypes = {
    plan: PropTypes.object.isRequired,
    onRemove: PropTypes.func.isRequired
};

export default SelectedPlan;